import { IconProp } from '@fortawesome/fontawesome-svg-core';
import IconButton from '../../components/IconButton';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Container, Row } from 'react-bootstrap';
import useMobile from '../../hooks/useMobileHook';
import CircledIcon, { CircledIconVariant } from '../CircledIcon';

export type PriceStyleType = 'disabled' | 'green' | 'default';

export type customAccordionBodyItemProps = {
  title?: string;
  subtitle?: string;
  subsubtitle?: React.ReactNode;
  infoIcon: IconProp;
  infoIconVariant?: CircledIconVariant;
  avatarGroup?: React.ReactNode;
  infoButton?: React.ReactNode;
  changeButton?: React.ReactNode;
  price: string;
  originalPrice?: string;
  isOriginalPriceShown?: boolean;
  priceStyleType: PriceStyleType;
  originalPriceStyleType?: PriceStyleType;
  isHint?: boolean;
  buttonOnMouseDown?: () => void;
};

const AccordionBodyItem = ({
  title,
  subtitle,
  subsubtitle,
  infoIcon,
  infoIconVariant = 'icon-emphasized',
  avatarGroup,
  infoButton,
  changeButton,
  price,
  originalPrice,
  isOriginalPriceShown = false,
  isHint,
  priceStyleType,
  originalPriceStyleType,
}: customAccordionBodyItemProps) => {
  const isMobile = useMobile();
  const icon = (iconName: IconProp) => (
    <CircledIcon
      variant={infoIconVariant}
      size={isMobile ? 'icon-sm' : 'icon-lg'}
      icon={iconName}
    />
  );
  
  return (
    <Container className="custom-accordion-demo">
      <Row className="m-0 body-rows">
        <Col className="p-0 col-2 col-lg-1">{icon(infoIcon)}</Col>
        <Col
          className={`p-0 px-lg-0 ${
            !infoButton && !changeButton ? 'col-lg-5' : 'col-lg-3'
          } col-9`}
        >
          <Col
            className={`p-0 col-10 d-flex flex-column justify-content-center`}
          >
            <Row className="m-0 p-0">
              <div className="p-0 fw-normal text-sub1 lh-xs">
                <span>{title}</span>
                {isHint && (
                  <FontAwesomeIcon
                    className="ms-2"
                    icon={light('circle-exclamation')}
                  />
                )}
              </div>
            </Row>
            <Row className="p-0">
              <div className="fw-light text-caption lh-xxs">
                <span>{subtitle}</span>
              </div>
            </Row>
            <Row className="p-0">
              <div className="fw-light text-caption lh-xxs">
                <span>{subsubtitle && subsubtitle}</span>
              </div>
            </Row>
          </Col>
        </Col>
        <Col
          className={`p-0 d-flex ${
            !infoButton && !changeButton ? 'col-lg-3' : 'col-lg-2'
          } justify-content-start col-6 mt-10 mt-lg-0`}
        >
          {avatarGroup}
        </Col>
        <Col
          className={`p-0 d-flex ${
            !infoButton && !changeButton
              ? 'justify-content-end col-lg-3'
              : 'justify-content-center col-lg-2'
          } ${infoButton && price && !changeButton ? 'col-lg-4' : 'col-lg-2'} ${
            isMobile && price && originalPrice ? 'col-12' : 'col-6'
          } mt-10 mt-lg-0`}
        >
          {isOriginalPriceShown && !isMobile && (
            <Col
              className={'price-col'}
            >
              <span>{`${originalPrice}`}</span>
            </Col>
          )}
          <Col
            className={`price-col ${
              isMobile && isOriginalPriceShown ? 'col-12' : ''
            } ${priceStyleType ? priceStyleType : ''}`}
          >
            <span>{`${price}${
              priceStyleType === 'green' ? ' (Credit)' : ''
            }`}</span>
          </Col>
        </Col>
        {infoButton && (
          <Col
            className={`p-0 d-flex justify-content-end align-items-center btns-col col-lg-2 mt-10 mt-lg-0 ${
              infoButton && price
            }`}
          >
            <div className={'d-flex justify-content-center'}>
              {infoButton && infoButton}
            </div>
          </Col>
        )}
        {changeButton && (
          <Col
            className={`p-0 d-flex col-3 justify-content-end align-items-center btns-col ${
              !infoButton ? 'col-lg-4' : 'col-lg-2'
            } mt-10 mt-lg-0`}
          >
            <div className={'d-flex justify-content-center'}>
              {changeButton && changeButton}
            </div>
          </Col>
        )}
      </Row>
    </Container>
  );
};

export default AccordionBodyItem;
